import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";

moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
  (state) => state.authorization,
  (authorization) => authorization
);
export const getCurrentRoute = createSelector(
  (state) => state.currentRoute,
  (currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
  (state) => state.currentTheme,
  (currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
  (state) => state.profile,
  (profile) => profile
);
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : profile.role
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
  (state) => state.notifications,
  (notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
  (state) => state.users,
  (users) => users
);
export const getUsersForm = createSelector(
  (state) => state.usersForm,
  (form) => form
);

/* ALERT */
export const getAlerts = createSelector(
  (state) => state.alerts,
  (alerts) => alerts
);
export const getAlertsForm = createSelector(
  (state) => state.alertsForm,
  (form) => form
);

/* EQUIPMENTS */
export const getEquipments = createSelector(
  (state) => state.equipments,
  (equipments) => equipments
);
export const getEquipmentsForm = createSelector(
  (state) => state.equipmentsForm,
  (form) => form
);

/* LOCATIONS */
export const getLocations = createSelector(
  (state) => state.locations,
  (locations) => locations
);
export const getLocationsForm = createSelector(
  (state) => state.locationsForm,
  (form) => form
);

/* ROLES */
export const getRoles = createSelector(
  (state) => state.roles,
  (roles) => roles
);
export const getRolesForm = createSelector(
  (state) => state.rolesForm,
  (form) => form
);

/* INCIDENTS */
export const getIncidents = createSelector(
  (state) => state.incidents,
  (incidents) => incidents
);
export const getIncidentsForm = createSelector(
  (state) => state.incidentsForm,
  (form) => form
);

/* WORKORDERS */
export const getWorkorders = createSelector(
  (state) => state.workorders,
  (workorders) => workorders
);
export const getWorkordersForm = createSelector(
  (state) => state.workordersForm,
  (form) => form
);

/* SHIFTTYPES */
export const getShifttypes = createSelector(
  (state) => state.shifttypes,
  (shifttypes) => shifttypes
);
export const getShifttypesForm = createSelector(
  (state) => state.shifttypesForm,
  (form) => form
);

/* APPOINTMENTS */
export const getAppointments = createSelector(
  (state) => state.appointments,
  (appointments) => appointments
);
export const getAppointmentsForm = createSelector(
  (state) => state.appointmentsForm,
  (form) => form
);
export const getBulkAppointmentsForm = createSelector(
  (state) => state.bulkAppointmentsForm,
  (form) => form
);
export const getMonthlySchedule = createSelector(
  (state) => state.monthlySchedule,
  (schedule) => schedule
);
export const getCurrentScheduleParams = createSelector(
  (state) => state.currentScheduleParams,
  (params) => params
);
export const getUserFilter = createSelector(
  (state) => state.userFilter,
  (filter) => filter
);

/* GROUPS */
export const getGroups = createSelector(
  (state) => state.groups,
  (groups) => groups
);
export const getGroupsForm = createSelector(
  (state) => state.groupsForm,
  (form) => form
);

/* PERMISSIONS */
export const getPermissions = createSelector(
  (state) => state.permissions,
  (permissions) => permissions
);
export const getPermissionsForm = createSelector(
  (state) => state.permissionsForm,
  (form) => form
);


export const getCurrentUserRoleObject = createSelector(
  [getCurrentUserRole, getRoles],
  (userRoleId, roles) => {
    if (!userRoleId || !roles) return null;
    return roles[userRoleId] || null;
  }
);
/* HOLIDAYS */
export const getHolidays = createSelector(
    (state) => state.holidays,
    (holidays) => holidays
);
export const getHolidaysForm = createSelector(
    (state) => state.holidaysForm,
    (form) => form
);

/* ATTENDANCERECORDS */
export const getAttendancerecords = createSelector(
    (state) => state.attendancerecords,
    (attendancerecords) => attendancerecords
);
export const getAttendancerecordsForm = createSelector(
    (state) => state.attendancerecordsForm,
    (form) => form
);

/* TIMECHANGEREQUESTS */
export const getTimechangerequests = createSelector(
    (state) => state.timechangerequests,
    (timechangerequests) => timechangerequests
);
export const getTimechangerequestsForm = createSelector(
    (state) => state.timechangerequestsForm,
    (form) => form
);

/* IRREGULARITYTYPES */
export const getIrregularitytypes = createSelector(
    (state) => state.irregularitytypes,
    (irregularitytypes) => irregularitytypes
);
export const getIrregularitytypesForm = createSelector(
    (state) => state.irregularitytypesForm,
    (form) => form
);

/* IRREGULARITYS */
export const getIrregularitys = createSelector(
    (state) => state.irregularitys,
    (irregularitys) => irregularitys
);
export const getIrregularitysForm = createSelector(
    (state) => state.irregularitysForm,
    (form) => form
);

/* MAINTENANCES */
export const getMaintenances = createSelector(
    (state) => state.maintenances,
    (maintenances) => maintenances
);
export const getMaintenancesForm = createSelector(
    (state) => state.maintenancesForm,
    (form) => form
);
